module.exports = __webpack_public_path__ + "img/trip-icon_apegoanormas.b86b00a2.svg";